import mixpanel from "mixpanel-browser"

export enum ACTIVITY_EVENTS {
  START = "Activity started",
  END = "Activity ended",
}

interface CommonProps {
  email: string
  name: string
  organization: string
}

interface StartActivityProps extends CommonProps {
  startDate: string
  subject: string
  prevStatus: string
  type: string
}

interface EndActivityProps extends CommonProps {
  approved: boolean
  score: number
  endDate: string
}

export function trackActivityEvent(
  event: ACTIVITY_EVENTS,
  props: StartActivityProps | EndActivityProps,
) {
  mixpanel.track(event, { ...props })
}

const activityEvents = {
  start: (props: StartActivityProps) => trackActivityEvent(ACTIVITY_EVENTS.START, props),
  end: (props: EndActivityProps) => trackActivityEvent(ACTIVITY_EVENTS.END, props),
}

export default activityEvents
